import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as DTOS from "../FeralScan.dtos";


export const serviceApi = {
    uploadFiles: (files: File[]): Observable<DTOS.UploadResponse> => {
        var client = new JsonServiceClient("");
        var request = new DTOS.Upload();

        let formData = new FormData();
        files.forEach(file => {
            formData.append('description', file.name);
            formData.append('type', 'file');
            formData.append('file', file);
        });

        const promise = client.postBody(request, formData);
        return Observable.from(promise);
    },
    deleteFile: (fileId: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.DeleteFile();

        request.fileId = fileId;

        const promise = client.delete(request);
        return Observable.from(promise);
    }
};
